<template>
    <v-autocomplete
        autofocus
        dense
        outlined
        :items="userCollection.models"
        :search-input.sync="searchInput"
        :loading="loading"
        no-filter
        chips
        hide-no-data
        :item-text="renderItem"
        item-value="id"
        return-object
        v-bind="$attrs"
        v-on="$listeners"
    >
        <template #item="data">
            <v-list-item-content>
                <v-list-item-title>
                    {{ data.item.username }} ({{ data.item.firstname }} {{ data.item.lastname }})
                </v-list-item-title>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>
import { delayed } from '@/helpers/tools';
import { UserCollection } from '@/models/User';

export default {
    name: 'UserSelect',

    props: {
        initialUserId: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            searchInput: '',
            userCollection: new UserCollection(),
            loading: false,
        };
    },

    watch: {
        searchInput: delayed(function (newVal, oldVal) {
            if (newVal?.length >= 3 && newVal !== oldVal) {
                this.query(newVal);
            }
        }, 350),
    },

    async mounted() {
        if (this.initialUserId) {
            await this.loadByUserId(this.initialUserId);
            this.$emit('input', this.userCollection.first());
        }
    },

    methods: {
        async loadByUserId(userId) {
            this.loading = true;
            await this.userCollection.query({ id: userId });
            this.loading = false;
        },
        async query(queryText) {
            this.loading = true;
            await this.userCollection.query({ query: queryText });
            this.loading = false;
        },
        renderItem(item) {
            return `${item.username} (${item.firstname} ${item.lastname})`;
        },
    },
};
</script>
